import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    // For now, just navigate to the planning page
    // Later you can add actual authentication logic
    navigate('/planning');
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h1>Pathway Planner</h1>
        <p>Plan your academic journey</p>
        <button onClick={handleLogin} className="login-button">
          Continue to Planning
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
